// src/screens/HomeScreen.jsx
import { useState } from "react";
import { T, Btn, Input, Label, Divider } from "../components/ui.jsx";

export default function HomeScreen({ onCreateRoom, onJoinRoom, onOpenDonate }) {
  const [name,     setName]     = useState("");
  const [joinCode, setJoinCode] = useState("");

  return (
    <div style={T.screen}>
      {/* Logo */}
      <div style={T.logo}>OMERTÀ</div>
      <div style={T.logoSub}>— A GAME OF SILENCE & DECEPTION —</div>

      {/* Card */}
      <div style={T.card}>
        <div style={T.cardTitle}>Enter the Underworld</div>

        <div style={{ marginBottom: "1.25rem" }}>
          <Label>Your Name</Label>
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="alias..."
            maxLength={20}
            onKeyDown={(e) => e.key === "Enter" && onCreateRoom(name)}
          />
        </div>

        <Btn onClick={() => onCreateRoom(name)}>Create Room</Btn>

        <Divider />

        <div style={{ marginBottom: "1.25rem" }}>
          <Label>Room Code</Label>
          <Input
            value={joinCode}
            onChange={(e) => setJoinCode(e.target.value.toUpperCase())}
            placeholder="e.g. XK9F2A"
            maxLength={6}
            style={{ letterSpacing: "0.2em", textTransform: "uppercase" }}
            onKeyDown={(e) => e.key === "Enter" && onJoinRoom(name, joinCode)}
          />
        </div>

        <Btn variant="ghost" onClick={() => onJoinRoom(name, joinCode)}>
          Join Room
        </Btn>
      </div>

      {/* Donate link */}
      {onOpenDonate && (
        <button
          onClick={onOpenDonate}
          style={{
            marginTop: "1.5rem",
            background: "transparent",
            border: "1px solid rgba(201,168,76,0.2)",
            borderRadius: 2,
            color: "var(--gold-dim)",
            padding: "0.5rem 1.1rem",
            fontFamily: "'Courier Prime', monospace",
            fontSize: "0.65rem",
            letterSpacing: "0.25em",
            textTransform: "uppercase",
            cursor: "pointer",
            transition: "color 0.18s, border-color 0.18s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = "var(--gold)";
            e.currentTarget.style.borderColor = "rgba(201,168,76,0.45)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = "var(--gold-dim)";
            e.currentTarget.style.borderColor = "rgba(201,168,76,0.2)";
          }}
        >
          ❦ Pay Tribute
        </button>
      )}
    </div>
  );
}
